<template>
  <div class="popup">
    <Popup v-model:show="show" position="bottom" :style="{ height: '40%' }">
      <Picker
        title="请选择考试"
        :columns="testArrayNew"
        @confirm="onConfirm"
        @cancel="onCancel"
        confirm-button-text="完成"
        :default-index="defaultIndex"
      />
    </Popup>
  </div>
</template>

<script>
import { Popup, Picker } from "vant";
import { ref, computed } from "vue";
export default {
  name: "LoginSelectTest",
  components: { Popup, Picker },
  emit: ["change-testName"],
  props: {
    // 考试数组
    testArray: {
      type: Array,
      default() {
        return [];
      },
    },
    defaultIndex: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  setup(props, context) {
    const show = ref(false);
    const testArrayNew = computed(() => {
      const array = [];
      props.testArray.forEach((item) => {
        array.push(item.name);
      });
      return array;
    });
    const onConfirm = (value) => {
      show.value = false;
      context.emit("change-testName", value);
    };
    const onCancel = () => {};
    return {
      show,
      onCancel,
      onConfirm,
      testArrayNew,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "scss/color.scss";
.popup :deep(.van-popup) {
  overflow: hidden;
}
.popup :deep(.van-picker__confirm) {
  color: var(--primary-color);
}
</style>
